import React, { memo } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
const useStyles = makeStyles((theme) => ({
  table: {
    // minWidth: 600,
    '& td, & th': {
      fontSize: '1em',
      [theme.breakpoints.down('sm')]: {
        fontSize: '0.6em',
      },
      [theme.breakpoints.up('sm')]: {
        fontSize: '1.1em',
      },
      [theme.breakpoints.up('xl')]: {
        fontSize: '1.5em',
      },
    },
  },
  tableRowHeader: {
    backgroundColor: theme.palette.grey[200],
    '& th': {
      fontSize: '1.2em',
    },
    [theme.breakpoints.up('xl')]: {
      fontSize: '1.6em',
    },
  },
  tableRow: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))
const OlcuTablosu = ({ rows, title }) => {
  const classes = useStyles()
  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="Ölçü Tablosu">
        <TableHead>
          <TableRow className={classes.tableRowHeader}>
            {title && (
              <TableCell align="center" colSpan={4}>
                {title}
              </TableCell>
            )}
          </TableRow>
          <TableRow>
            <TableCell>Göz Aralığı</TableCell>
            <TableCell align="right">Yükseklik</TableCell>
            <TableCell align="right">Genişlik</TableCell>
            <TableCell align="right">Tel Kalınlığı</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => (
            <TableRow key={index} className={classes.tableRow}>
              <TableCell component="th" scope="row">
                {row.gAralik}
              </TableCell>
              <TableCell align="right">{row.yukseklik}</TableCell>
              <TableCell align="right">{row.genislik}</TableCell>
              <TableCell align="right">{row.kalinlik}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
export default memo(OlcuTablosu)
